import { useState, useRef, useEffect } from "react";

const DesiredScoreCard = ({ desiredScore: initialDesiredScore }) => {
  // ✅ local state is the source of truth
  const [desiredScore, setDesiredScore] = useState(initialDesiredScore ?? null);
  const [tempScore, setTempScore] = useState("");
  const [showPicker, setShowPicker] = useState(false);

  const popupRef = useRef(null);

  // Close popup on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  // 🔹 Save score to DB
  const handleSetScore = async () => {
    if (!tempScore || tempScore < 10 || tempScore > 90) return;

    try {
      await fetch("/api/user-preferences", {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ desiredScore: tempScore }),
      });

      // ✅ update UI
      setDesiredScore(tempScore);
      setTempScore("");
      setShowPicker(false);
    } catch (err) {
      console.error("Failed to save desired score");
    }
  };

  return (
    <div
      className="group relative flex-1 md:w-1/4 px-32 py-4 md:px-10 md:py-10 mx-5 mt-3 md:mt-0 
                 bg-white rounded-sm cursor-pointer hover:ring-1 hover:ring-purple-300 transition"
      onClick={() => !showPicker && setShowPicker(true)}
    >
      <span className="absolute top-3 right-3 text-gray-400 opacity-0 group-hover:opacity-100 transition">
        ✏️
      </span>

      <h3 className="text-center font-bold text-sm mb-8 underline text-gray-700">
        Desired Score
      </h3>

      <h4 className="font-extrabold text-gray-700 text-center">
        {desiredScore ?? "N/A"}
      </h4>

      {!desiredScore && (
        <p className="text-xs text-gray-400 text-center mt-1">
          Click to set target score
        </p>
      )}

      {showPicker && (
        <div
          ref={popupRef}
          className="absolute top-full left-1/2 -translate-x-1/2 mt-3 bg-white border border-gray-300 
                     rounded-md shadow-xl p-4 z-50 w-48"
        >
          <p className="text-xs text-gray-500 mb-2 text-center">
            Set target score
          </p>

          <input
            type="number"
            min="10"
            max="90"
            placeholder="Enter score"
            value={tempScore}
            onChange={(e) => setTempScore(e.target.value)}
            className="w-full border border-gray-300 rounded px-2 py-1 text-sm text-center mb-3"
          />

          <button
            onClick={handleSetScore}
            className="block mx-auto rounded-full border bg-gray-900 px-12 py-3 text-center text-sm 
                       font-medium text-gray-200 bg-gradient-to-r from-fuchsia-900 to-fuchsia-700
                       hover:ring-1 hover:ring-purple-500 transition"
          >
            Set Score
          </button>
        </div>
      )}
    </div>
  );
};

export default DesiredScoreCard;
